import React from "react";
import Header from "./homeComponents/Header";
import IntroSection from "./homeComponents/IntroSection";
import MentorSection from "./homeComponents/MentorSection";
import ExpertConnectSection from "./homeComponents/ExpertConnectSection";
import MentorSuggestions from "./homeComponents/MentorSuggestions";
import ExpertSuggestions from "./homeComponents/ExpertSuggestions";
import Cards from "./homeComponents/Cards";
// import CareerDataSection from "./homeComponents/CareerDataSection";
import Footer from "./homeComponents/Footer";
import CareerProgress from "./homeComponents/CareerProgress";
import { useAuth } from "./AuthContext";
import "./HomePage.css";
import SeminarSection from "./homeComponents/SeminarSection";
import AboutUs from "./homeComponents/AboutUs";
import UserFeedback from "./homeComponents/UserFeedback";

const HomePage = () => {
  const { userData } = useAuth();

  const renderIntroSection = () => {
    if (!userData) {
      return (
        <IntroSection
          userData={userData}
          primaryText="Unlock Your Dream Career"
          typewriterStrings={["Explore. Connect. Achieve.", "Let your Journey start here!"]}
          tertiaryText="Find the right guidance for every career choice."
          quaternaryText="Connect with experts directly."
          buttonText="Find your Career!"
          onButtonClick={() => console.log("User Button Clicked")}
        />
      );
    }

    if (userData.role === "mentors") {
      return (
        <>
          <IntroSection
            userData={userData}
            primaryText="Welcome, Career Coach!"
            typewriterStrings={["Guide. Inspire. Empower.", "Your expertise matters!"]}
            tertiaryText="Provide the right guidance for Individuals."
            quaternaryText="Share your journey with the next generation."
            buttonText="Start Mentoring!"
            onButtonClick={() => console.log("Mentor Button Clicked")}
          />
          {/* <MentorSuggestions userData={userData} /> */}
        </>
      );
    }

    if (userData.role === "experts") {
      return (
        <>
          <IntroSection
            userData={userData}
            primaryText="Hello, Expert!"
            typewriterStrings={["Advice. Enhance. Elevate.", "Make a real difference!"]}
            tertiaryText="Help Individuals achieve their career goals."
            quaternaryText="Your experience can change lives."
            buttonText="Share Your Expertise!"
            onButtonClick={() => console.log("Expert Button Clicked")}
          />
          {/* <ExpertSuggestions userData={userData} /> */}
        </>
      );
    }

    // Default for users
    return (
      <IntroSection
        userData={userData}
        primaryText="Unlock Your Dream Career"
        typewriterStrings={["Explore. Connect. Achieve.", "Let your Journey start here!"]}
        tertiaryText="Find the right guidance for every career choice."
        quaternaryText="Connect with experts directly."
        buttonText="Find your Career!"
        onButtonClick={() => console.log("User Button Clicked")}
      />
    );
  };

  const renderDefaultComponents = () => {
    if (!userData || (userData.role !== "mentors" && userData.role !== "experts")) {
      return (
        <>
          <CareerProgress />
          <Cards />
          {/* <CareerDataSection /> */}
          <MentorSection />
          <ExpertConnectSection />
          <SeminarSection />
          {/* Testimony section & FAQ */}
          <UserFeedback />
          <AboutUs />
          <Footer />
        </>
      );
    }
    return null;
  };

  return (
    <div className="homepage">
      <Header />
      {renderIntroSection()}
      {renderDefaultComponents()}
    </div>
  );
};

export default HomePage;
